import { Grid, Input, InputWrapperProps } from '@mantine/core'
import { PropsWithChildren } from 'react'

type HorizontalFieldProps = PropsWithChildren<InputWrapperProps>

export const HorizontalField = ({
  children,
  ...wrapperProps
}: HorizontalFieldProps) => (
  <Grid align="center">
    <Grid.Col span={{ base: 12, sm: 6 }}>
      <Input.Wrapper {...wrapperProps} />
    </Grid.Col>
    <Grid.Col span={{ base: 12, sm: 6 }}>{children}</Grid.Col>
  </Grid>
)
